import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from 'antd';
import { buyIntentionActions, sessionActions } from 'store/state/slices';
import { HeaderEnum } from 'enums/header.enum';
import {
  FeatureFlags,
  useFeatureFlagStore,
} from 'zustand/featureFlag/useFeatureFlagStore';
import * as BuyIntentionCalls from 'store/state/buyIntention/apiCalls';
import { sessionSelectors } from 'store/state/selectors';
import { useTranslation } from 'react-i18next';
import { getRefreshTokenService, setLogout } from 'services/config';
import { logoutSession } from 'services/sessions/SessionsService';
import { LogoutOutlined } from '@ant-design/icons';

function UserMenuOverlay() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { producerUrl } = useSelector(sessionSelectors.getRoot);
  const { t } = useTranslation('translation', { keyPrefix: 'header' });

  const isFeatureFlagEnabled = useFeatureFlagStore(
    (state) => state.isFeatureFlagEnabled,
  );

  const isDeskManagerServiceRequestsEnabled = isFeatureFlagEnabled(
    FeatureFlags.DeskManagerServiceRequestsOnECommerce,
  );

  const isProducerAuthenticated = useSelector(
    sessionSelectors.isProducerAuthenticated,
  );

  const handleClickMyOrders = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/${producerUrl}/my-orders`);
  };

  const handleClickMyOrderIntentions = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/${producerUrl}/my-order-intentions`);
  };

  const handleClickServiceRequest = () => {
    if (!isDeskManagerServiceRequestsEnabled) {
      window.open(HeaderEnum.LINKSUPPORT);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      navigate(`/${producerUrl}/service-request`);
    }
  };

  const handleClickBuyIntention = () => {
    dispatch(buyIntentionActions.setShowIntentionModal(true));
    dispatch(BuyIntentionCalls.fetchProducers());
  };

  const logout = useCallback(async () => {
    const refresh = getRefreshTokenService();
    if (refresh) {
      try {
        await logoutSession(refresh);
      } catch {
        // best-effort: continua mesmo se backend falhar
      }
    }
    setLogout();
    dispatch(sessionActions.logout());
    navigate('/logout');
  }, [dispatch, navigate]);

  return (
    <>
      {!isProducerAuthenticated && (
        <Menu.Item key="drop-down-actions-1" onClick={handleClickMyOrders}>
          {t('myOrders')}
        </Menu.Item>
      )}
      <Menu.Item
        key="drop-down-actions-5"
        onClick={handleClickMyOrderIntentions}
      >
        {t('myOrderIntentions')}
      </Menu.Item>
      <Menu.Item key="drop-down-actions-4" onClick={handleClickBuyIntention}>
        {t('registerOrderIntention')} +
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={handleClickServiceRequest} key="drop-down-actions-2">
        {t('openRequests')}
      </Menu.Item>
      <Menu.Item onClick={logout} key="drop-down-actions-3">
        {t('logout')} <LogoutOutlined />
      </Menu.Item>
    </>
  );
}

export default UserMenuOverlay;
